import { PendingStatus, DatasetStatus } from '@components'

/**
 * Displays a filled circle indicating the current status of the submission
 *
 * @param {Props} props **React props**
 * @param {DatasetStatus} status - Submission status
 */
export const StatusCircle = ({ status }) => {
  switch (status) {
    case DatasetStatus.PENDING: {
      return <div className="status-indicator pending" />
    }
    case PendingStatus.ERROR: {
      return <div className="status-indicator error" />
    }
    case DatasetStatus.WARNING: {
      return <div className="status-indicator warning" />
    }
    case DatasetStatus.COMPLETE: {
      return <div className="status-indicator success" />
    }
    default: {
      return null
    }
  }
}
